// @ts-nocheck
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import LeafletMap from '../../components/LeafletMap'
import {
	Button,
} from '../../components/StyledComponents'
import { ErrorMessage } from '../../components/ui/ErrorMessage'
import { Page } from '../../components/ui/Page'
import { Title } from '../../components/layout/Title'
import { Stepper } from '../../components/features/Stepper'
import { Body } from '../../components/layout/Body'
import { Checkbox } from '../../components/ui/Checkbox'
import { BackArrow } from '../../components/Icons'
import DateFormat from '../../lib.r2/utils/DateFormat'
import Store from '../../store/Store'
import { bookingStepLabels } from './bookingStepLabels'

// Taxativer Katalog – zulässige Rechtsgrundlagen der Verarbeitung
const PERMITTED_BASES = [
	{ key: 'consent', label: 'Die betroffene Person hat zugestimmt.' },
	{ key: 'contract', label: 'Es gibt eine gesetzliche Grundlage dafür oder einen Vertrag, der erfüllt werden soll.' },
	{ key: 'vitalInterests', label: 'Es dient dem Schutz lebenswichtiger Interessen (z. B. Sicherheit).' },
	{ key: 'publicTask', label: 'Es ist für die Erfüllung einer öffentlichen Aufgabe notwendig.' },
	{ key: 'legitimateInterests', label: 'Es liegt ein berechtigtes Interesse vor.' },
]

// Aufzeichnungsverbot – Fälle, die nicht vorliegen dürfen
const PROHIBITIONS = [
	{ key: 'privacyIntrusion', label: 'Es wird in die Privatsphäre anderer eingegriffen.' },
	{ key: 'faceRecognition', label: 'Die Daten werden für Gesichtserkennung oder automatisierte Auswertung genutzt.' },
	{ key: 'specialData', label: 'Es werden besonders geschützte Daten (z. B. Gesundheit) verarbeitet.' },
	{ key: 'consentWithdrawn', label: 'Die Zustimmung zur Datenaufnahme wurde widerrufen.' },
]

// ============================================================================
// 4. Buchung überprüfen

const BookingPage4 = () => {
	const bookingData = Store.bookingData
	const priceData = bookingData?.priceData

	const [agree, setAgree] = useState(false)
	const [affidavit, setAffidavit] = useState(false)
	const [valid, setValid] = useState(true)
	const [error, setError] = useState('')
	const [dontPublishData, setDontPublishData] = useState(false)
	const [isOrdering, setIsOrdering] = useState(false)

	if (!bookingData) return null

	const finalPriceWithoutPrivacy =
		priceData?.finalPriceWithoutPrivacy ||
		priceData?.finalPriceWithoutPrivat ||
		priceData?.finalPrice ||
		0

	const finalPriceWithPrivacy =
		priceData?.finalPriceWithPrivacy ||
		priceData?.finalPriceWithPrivat ||
		priceData?.finalPrice ||
		0
	const totalPrice = dontPublishData
		? finalPriceWithPrivacy
		: finalPriceWithoutPrivacy

	const subsidy = Math.max(
		0,
		(finalPriceWithPrivacy || 0) - (finalPriceWithoutPrivacy || 0)
	)

	const formattedDateRange =
		bookingData.dateFrom && bookingData.dateTo
			? `${DateFormat(bookingData.dateFrom, 'dd.mm.yyyy')} - ${DateFormat(
				bookingData.dateTo,
				'dd.mm.yyyy'
			)}`
			: '-'

	const purposesContent =
		Array.isArray(bookingData.purposes) && bookingData.purposes.length > 0
			? bookingData.purposes
			: []

	const handleOrder = async () => {
		if (isOrdering) return;
		setError('')
		setIsOrdering(true)

		if (!affidavit) {
			setValid(false)
			setError('Bitte bestätigen Sie die eidesstattliche Erklärung.')
			setIsOrdering(false)
			return
		}

		if (!agree) {
			setValid(false)
			setError('Bitte stimmen Sie der Datenschutzrichtlinie zu.')
			setIsOrdering(false)
			return
		}

		try {
			const preparedCoordinates =
				typeof bookingData.coordinates === 'object'
					? (() => {
						const coordinatesCopy = { ...bookingData.coordinates }
						delete coordinatesCopy._polygon
						return JSON.stringify(coordinatesCopy)
					})()
					: bookingData.coordinates

			const savedDates =
				bookingData.dateFrom && bookingData.dateTo
					? `${DateFormat(bookingData.dateFrom, 'dd.mm.yyyy')} - ${DateFormat(
						bookingData.dateTo,
						'dd.mm.yyyy'
					)}`
					: ''
			const preparedBookingData = {
				...bookingData,
				coordinates: preparedCoordinates,
				price: totalPrice,
				_savedDates: savedDates,
				resultTypes: bookingData.resultTypes ?? [],
			}

			if (dontPublishData) {
				localStorage.setItem(bookingData.name, 'discount')
			}

			console.log('BOOKING DATA READY FOR ORDER:', preparedBookingData)

			const result = await Store.createOrder(preparedBookingData)

			console.log('CREATE ORDER RESULT:', result)


			if (!result) {
				setError('Fehler beim Erstellen der Bestellung.')
				setIsOrdering(false)
				return
			}

			if (result.error) {
				setError(result.error)
				setIsOrdering(false)
				return
			}

			if (result.message) {
				setError(result.message)
				setIsOrdering(false)
				return
			}

			const orderId = result.orderId || result.id || null

			if (!orderId) {
				setError('Bestellung wurde erstellt, aber keine Auftragsnummer wurde zurückgegeben.')
				return
			}

			Store.latestOrderId = orderId

			Store.setBookingData({
				id: orderId,
				coordinates: preparedCoordinates,
				price: totalPrice,
				_savedDates: savedDates,
			})

			console.log('BOOKING DATA READY FOR PAYMENT:', Store.bookingData)
			console.log('LATEST ORDER ID:', Store.latestOrderId)

			Store.navigate('booking/page_5')
		} catch (err) {
			console.error('create order error:', err)
			setError('Fehler beim Erstellen der Bestellung.')
		} finally {
			setIsOrdering(false)
		}
	}

	return (
		<div className="max-w-[1100px] mx-auto">
			<Page>
				<Body>
					<Stepper numSteps={5} step={4} labels={bookingStepLabels} />

					<div className="w-full">
						<Title>Buchung überprüfen</Title>

						<div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-10 mt-10">
							<div>
								<div className="rounded-[20px] overflow-hidden max-h-[450px]">
									<LeafletMap coordinates={bookingData.coordinates} />
								</div>

								<div className="grid grid-cols-[220px_1fr] gap-y-6 gap-x-6 mt-10 text-[18px] leading-[1.35]">
									<div className="font-semibold">Name Ihrer Bestellung</div>
									<div>{bookingData.name || '-'}</div>

									{/* <div className="font-semibold">Anwendungsfall</div>
									<div>{bookingData.selectedServiceId || bookingData.mission || '-'}</div> */}

									{/* <div className="font-semibold">Auswertungsart</div>
									<div>
										{purposesContent.length > 0 ? (
											<div className="flex flex-col gap-1">
												{purposesContent.map((purpose, index) => (
													<div key={`${purpose?.name || 'purpose'}-${index}`}>
														{typeof purpose === 'string' ? purpose : purpose?.name}
													</div>
												))}
											</div>
										) : (
											'-'
										)}
									</div> */}

									<div className="font-semibold">Befliegungszeitraum</div>
									<div>{formattedDateRange}</div>

									<div className="font-semibold">Koordinatensystem</div>
									<div>{bookingData.coordinateSystem === 'EPSG:31255' ? 'EPSG-Code 31255 (Gauß-Krüger M31)' : 'EPSG-Code 4326 (WGS 84)'}</div>

									<div className="font-semibold">Ground Control Points</div>
									<div>{bookingData.gcpFileName || '-'}</div>

									<div className="font-semibold">Weitere Informationen</div>
									<div>{bookingData.information || '-'}</div>
								</div>

							</div>

							<div>
								<div className="bg-[#EEF5FB] rounded-[20px] p-8 shadow-sm">
									<h2 className="text-2xl font-semibold mb-8">
										Bestellung Drohnenflug
									</h2>

									<div className="space-y-3 text-[16px]">
										<div className="flex items-start justify-between gap-4">
											<span>Flugkosten inkl. Auswertung</span>
											<span>€ {Number(finalPriceWithPrivacy *1.2 || 0).toFixed(2)}</span>
										</div>

										{!dontPublishData && subsidy > 0 && (
											<div className="flex items-start justify-between gap-4">
												<span>Zuschuss: Daten veröffentlichen</span>
												<span>- € {subsidy.toFixed(2)}</span>
											</div>
										)}
									</div>

									<div className="border-t border-[#A9B4BF] my-5" />

									<div className="space-y-3 text-[16px]">
										<div className="flex items-start justify-between gap-4">
											<span>Zwischensumme</span>
											<span>€ {Number(totalPrice *1.2 / 1.2 || 0).toFixed(2)}</span>
										</div>

										<div className="flex items-start justify-between gap-4">
											<span>MwSt. (20 %)</span>
											<span>€ {Number(totalPrice - totalPrice / 1.2 || 0).toFixed(2)}</span>
										</div>
									</div>

									<div className="border-t border-[#A9B4BF] my-5" />

									<div className="flex items-start justify-between gap-4 text-[18px] font-semibold">
										<span>Gesamtsumme</span>
										<span>€ {Number(totalPrice *1.2 || 0).toFixed(2)}</span>
									</div>

									<div className="mt-8">
										<Checkbox
											data-pw="checkbox-privacy"
											label="Ich möchte meine Daten nicht veröffentlichen."
											selected={dontPublishData}
											onSelect={() => setDontPublishData(!dontPublishData)}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="mt-16">
							<h2 className="text-2xl font-semibold mb-6">
								Eidesstattliche Erklärung
							</h2>

							<div className="max-w-[900px]">
								<Checkbox
									data-pw="checkbox-affidavit"
									label="Ich erkläre eidesstattlich, dass ich berechtigt bin, die im Rahmen dieses Auftrags erhobenen Daten aufzunehmen und zu verarbeiten. Die Verarbeitung erfolgt auf mindestens einer der unten genannten Rechtsgrundlagen und es liegt keiner der Fälle des Aufzeichnungsverbots vor."
									selected={affidavit}
									onSelect={e => {
										setAffidavit(e)
										if (e) setError('')
										if (e && agree) setValid(true)
									}}
									invalid={!valid && !affidavit}
								/>
							</div>

							<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
								<div className="bg-[#F7F7F7] rounded-[20px] p-7 border-l-4 border-[#E0A100]">
									<div className="flex items-center gap-4 mb-5">
										<h3 className="text-xl font-bold">Erlaubte Verarbeitung</h3>
										<span className="ml-auto w-12 h-6 rounded bg-[#3FAE5A]" />
									</div>
									<ul className="flex flex-col gap-3">
										{PERMITTED_BASES.map(basis => (
											<li key={basis.key} className="flex gap-3 text-[16px] leading-[1.35]">
												<span className="mt-[7px] w-[7px] h-[7px] min-w-[7px] bg-[#E0A100]" />
												<span>{basis.label}</span>
											</li>
										))}
									</ul>
								</div>

								<div className="bg-[#F7F7F7] rounded-[20px] p-7 border-l-4 border-[#E0A100]">
									<div className="flex items-center gap-4 mb-5">
										<h3 className="text-xl font-bold">Aufzeichnungsverbot</h3>
										<span className="ml-auto w-12 h-6 rounded bg-[#C0392B]" />
									</div>
									<ul className="flex flex-col gap-3">
										{PROHIBITIONS.map(item => (
											<li key={item.key} className="flex gap-3 text-[16px] leading-[1.35]">
												<span className="mt-[7px] w-[7px] h-[7px] min-w-[7px] bg-[#E0A100]" />
												<span>{item.label}</span>
											</li>
										))}
									</ul>
								</div>
							</div>

							<div className="mt-8">
								<Checkbox
									data-pw="checkbox-agreement"
									label={<>
										Ich stimme den{' '}
										<Link
											to="/policy"
											style={{ textDecoration: 'underline', color: '#0063A3' }}
											target="_blank"
											rel="noopener noreferrer"
										>
											Datenschutzrichtlinien
										</Link>
										{' '}zu.
									</>}
									selected={agree}
									onSelect={e => {
										setAgree(e)
										if (e) setError('')
										if (e && affidavit) setValid(true)
									}}
									invalid={!valid && !agree}
								/>
							</div>

							{error && (
								<div className="mt-4">
									<ErrorMessage>{error}</ErrorMessage>
								</div>
							)}

							<div className="mt-5 flex flex-wrap gap-4">
								<div className="w-[220px]">
									<Button
										className="border border-[#E1320F] text-[#E1320F] bg-white"
										data-pw="button-edit-booking-order"
										onClick={() => Store.navigate('booking/page_3')}
									>
										<BackArrow /> Angaben bearbeiten
									</Button>
								</div>

								<div className="w-[260px]">
									<Button
										data-pw="button-order"
										primary
										onClick={handleOrder}
										disabled={isOrdering}
									>
										{isOrdering ? 'Bitte warten...' : 'Kostenpflichtig buchen'}
									</Button>
								</div>
							</div>
						</div>
					</div>
				</Body>
			</Page>
		</div>
	)
}

export default BookingPage4
